import { withStyles, withTheme, Popover } from "@material-ui/core";
import DateRangeInputBox from "../../Reports/DriverPerformance/components/DateRangeInputBox";
import DateRangePicker from "../../Reports/DriverPerformance/components/DateRangePicker";
import { format, isValid } from "date-fns";
import { compose } from "recompose";

const styles = () => ({
  fieldContainer: {
    display: "flex",
    flexDirection: "column",
  },
});

class CustomDateRange extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openCalendar: false,
      anchorEl: null,
    };
  }

  openCalendar = (event) => {
    this.setState({
      openCalendar: true,
      anchorEl: document.getElementById("CustomDateRange"),
    });
  };

  closeDateRangePicker = () => {
    this.setState({ openCalendar: false, anchorEl: null });
  };

  render() {
    const {
      startDate,
      endDate,
      dateRange,
      dateFormat,
      classes,
      startDatePlaceholder,
      endDatePlaceholder,
      theme,
      transformOriginValue,
      ...otherProps
    } = this.props;
    const { openCalendar, anchorEl } = this.state;
    return (
      <div className={classes.fieldContainer} id="CustomDateRange">
        {!openCalendar && (
          <div >
            <DateRangeInputBox
              startDate={
                startDate && isValid(startDate)
                  ? format(startDate, dateFormat)
                  : startDatePlaceholder
              }
              endDate={
                endDate && isValid(endDate)
                  ? format(endDate, dateFormat)
                  : endDatePlaceholder
              }
              onClick={this.openCalendar}
            />
          </div>
        )}
        {openCalendar && (
          <Popover
            id="CustomDateRange"
            open={true}
            anchorEl={anchorEl}
            onClose={this.closeDateRangePicker}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: transformOriginValue,
            }}
          >
            <DateRangePicker
              rangeColors={[theme.HeaderSelectedText]}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={1}
              startDatePlaceholder={startDatePlaceholder}
              endDatePlaceholder={endDatePlaceholder}
              ranges={dateRange}
              inputRanges={[]}
              dateDisplayFormat={dateFormat}
              direction="vertical"
              editableDateInputs
              color={theme.HeaderSelectedText}
              handleClose={this.closeDateRangePicker}
              staticRanges={[]}
              {...otherProps}
            />
          </Popover>
        )}
      </div>
    );
  }
}

export default compose(withTheme(), withStyles(styles))(CustomDateRange);
